const common = {
  siteName: '韩漫之家',
  tagline: '免费韩漫大全 · 好看韩国漫画在线观看',
  nav: {
    home: '首页',
    categories: '分类',
    about: '关于我们',
    search: '搜索漫画...',
  },
  home: {
    heroTitle: '发现你最爱看的',
    heroTitleHighlight: '韩国漫画',
    heroSubtitle: '海量高品质韩漫免费在线观看，每日更新，畅享阅读乐趣',
    heroCTA: '开始阅读',
    heroSecondary: '了解更多',
    featuredTitle: '编辑精选',
    featuredSubtitle: '编辑团队精心挑选的高质量韩漫作品',
    latestTitle: '最新更新',
    latestSubtitle: '实时同步最新章节，追更不落空',
    popularTitle: '人气排行',
    popularSubtitle: '最受欢迎的热门韩漫作品',
    categoryTitle: '分类浏览',
    categorySubtitle: '按你喜欢的类型轻松找到心仪漫画',
    faqTitle: '常见问题',
    faqSubtitle: '关于韩漫之家的常见疑问',
    statsComics: '收录漫画',
    statsVisitors: '日访问量',
    statsUpdates: '月更新章节',
    statsRating: '用户评分',
  },
  category: {
    title: '漫画分类',
    allComics: '全部漫画',
    resultCount: '共 {{count}} 部漫画',
    filterBy: '筛选',
    sortNewest: '最新更新',
    sortPopular: '最受欢迎',
    sortRating: '最高评分',
    noComics: '暂无该分类的漫画',
  },
  article: {
    author: '作者',
    status: '状态',
    chapters: '章节数',
    updateDate: '最近更新',
    rating: '评分',
    views: '浏览量',
    tags: '标签',
    description: '作品简介',
    chapterList: '章节列表',
    latestChapter: '最新章节',
    relatedComics: '相关推荐',
    ongoing: '连载中',
    completed: '已完结',
    startReading: '开始阅读',
    backToList: '返回列表',
  },
  about: {
    title: '关于韩漫之家',
    introTitle: '品牌介绍',
    introContent: '韩漫之家成立于2018年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供最全面、最优质的韩国漫画资源，涵盖恋爱、动作、奇幻、搞笑、悬疑、治愈、剧情等多种类型，满足不同读者的阅读需求。',
    reputationTitle: '口碑声誉',
    contactTitle: '联系我们',
    contactAddress: '公司地址',
    contactPhone: '联系电话',
    contactEmail: '电子邮箱',
    contactSocial: '社交媒体',
  },
  footer: {
    copyright: '© 2026 韩漫之家 版权所有',
    privacy: '隐私政策',
    terms: '使用条款',
    sitemap: '网站地图',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    article: '漫画详情',
    about: '关于我们',
  },
  status: {
    ongoing: '连载中',
    completed: '已完结',
  },
};

export default common;